import React from 'react';
import { Row, Button, Col, Avatar, Popconfirm } from 'antd';
import { observer, inject } from 'mobx-react';
import styles from './List.less';
import UploadFile from './UploadFile';
import { timeBr } from '../lib/lib';

@inject('appFirmwareStore', 'appFileStore')
@observer
class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unfold: false
    };
    this.unfoldFunc = this.unfoldFunc.bind(this);
  }

  unfoldFunc() {
    this.setState({
      unfold: !this.state.unfold
    });
  }
  render() {
    const { BasicInfo, btnType, histroyList } = this.props;
    const { unfold } = this.state;
    return (
      <div className={styles.list}>
        <div className={styles.listTop}>
          <Row className={styles.msgContainer}>
            <Col span={4} offset={1}>
              <Avatar
                src={BasicInfo.icon ? '/api' + BasicInfo.icon : ''}
                shape="square"
                size="large"
                icon="android-o"
                style={{ backgroundColor: '#97c021' }}
              />
            </Col>
            <Col span={18} offset={1}>
              <p>名称 : {BasicInfo['app_name'] || BasicInfo.fileName}</p>
              {!BasicInfo.fileName && <p>描述 : {BasicInfo.app_description}</p>}
              {!BasicInfo.fileName && (
                <p>
                  最新上传文件版本号 :{' '}
                  {histroyList[histroyList.length - 1].app_version}
                </p>
              )}
              {BasicInfo.fileName && <p>md5 : {BasicInfo.md5}</p>}
            </Col>
          </Row>
          {btnType === 'fileBtn' && (
            <FileBtn
              unfold={unfold}
              unfoldFunc={this.unfoldFunc}
              id={BasicInfo.app_id}
              uploadAppFile={this.props.appFileStore.uploadAppFile}
            />
          )}
          {btnType === 'firmwareBtn' && (
            <FirmwareBtn
              fileName={BasicInfo.fileName}
              deleteFirmware={this.props.appFirmwareStore.deleteFirmware}
            />
          )}
        </div>

        {unfold && (
          <div className={styles.histroyList}>
            <div className={styles.listBox}>
              <span className={styles.listSpan}>安装包名称</span>
              <span className={styles.listSpan}>版本</span>
              <span className={styles.listSpan}>上传日期</span>
            </div>
            <div className={styles.histroyListContainer}>
              {histroyList.map((item, index) => (
                <div className={styles.listBox} key={index}>
                  <span className={styles.listSpan}>
                    {BasicInfo['app_name']}
                  </span>
                  <span className={styles.listSpan}>{item.app_version}</span>
                  <span
                    className={`${styles.listSpan} ${styles.dateContainer}`}
                  >
                    {timeBr(item.update_time)}
                  </span>
                  <p>MD5: &nbsp;{item.md5}</p>
                </div>
              ))}
            </div>
            <Row className={styles.innerBtn}>
              <Col span={16}>
                <Button type="primary" onClick={this.unfoldFunc}>
                  收起上传历史
                </Button>
              </Col>
              <Col span={4}>
                <Popconfirm
                  title="确认要删除该App吗?"
                  onConfirm={() => {
                    this.props.appFileStore.deleteApp(BasicInfo.app_id);
                    this.setState({
                      unfold: false
                    });
                  }}
                  onCancel={() => {}}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button type="danger">删除App</Button>
                </Popconfirm>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
@observer
class FileBtn extends React.Component {
  constructor(props) {
    super(props);
    this.unload = this.unload.bind(this);
  }
  unload(file) {
    const data = new FormData();
    data.append('file', file);
    this.props.uploadAppFile(this.props.id, data);
  }
  render() {
    const { unfold, unfoldFunc } = this.props;
    return (
      <Row className={styles.btnGroup}>
        <Col span={12}>
          {!unfold ? <Button onClick={unfoldFunc}>安装包上传历史</Button> : ''}
        </Col>
        <Col span={7} offset={4}>
          <UploadFile fileName={'上传安装包'} onChange={this.unload} />
        </Col>
      </Row>
    );
  }
}
class FirmwareBtn extends React.Component {
  render() {
    const { fileName, deleteFirmware } = this.props;
    return (
      <Row className={styles.btnGroup}>
        <Col span={4} offset={18}>
          <Popconfirm
            title="确认要删除该固件吗?"
            onConfirm={() => deleteFirmware(fileName)}
            onCancel={() => {}}
            okText="确认"
            cancelText="取消"
          >
            <Button type="danger">删除</Button>
          </Popconfirm>
        </Col>
      </Row>
    );
  }
}
export default List;



// WEBPACK FOOTER //
// ./src/components/List.js